"use client";

import { ChevronLeftIcon } from "@heroicons/react/24/solid";
import Link from "next/link";
import { useRouter } from "next/navigation";

export default function BackButton({
    text = "Back",
    onClick,
    redirectURL,
}: {
    text?: string;
    onClick?: () => void;
    redirectURL?: string;
}) {
    const router = useRouter();

    if (redirectURL) {
        return (
            <Link href={redirectURL}>
                <div className="pt-3 pl-3 flex items-center gap-1">
                    <ChevronLeftIcon className="h-6 w-6 text-gray-400" />
                    <span className="text-gray-400 font-medium font-suisse leading-relaxed">
                        {text}
                    </span>
                </div>
            </Link>
        );
    }

    return (
        <button
            className="pt-3 pl-3 flex items-center gap-1"
            onClick={() => {
                if (redirectURL) {
                    router.push(redirectURL);
                } else if (onClick) {
                    onClick();
                } else {
                    // Close the tab
                    window.close();
                }
            }}
        >
            <ChevronLeftIcon className="h-6 w-6 text-gray-400 dark:text-gray-300" />
            <span className="text-gray-400 font-medium font-suisse leading-relaxed dark:text-gray-300">
                {text}
            </span>
        </button>
    );
}
